/*
 * @Author: summer
 * @Date: 2021-12-07 19:30:38
 * @LastEditors: summer
 * @LastEditTime: 2021-12-12 10:28:34
 */

import _comMeds from '@src/assets/js/common.js';
import _order from '@src/assets/js/server/order-server';
import _headMask from "@src/assets/js/server/head-mask.js"
import '@src/assets/js/table.js';
import './index.scss'

new Vue({
    el: '#app',
    data() {
        return {
            levelData: ['仅校对', '阅读级', '商务级', '仅校对', '阅读级', '商务级'],
            tableData:[],
            tableData2: [],
            tableData3: [
                {type:'标准',item:'公证书',label1:'75起',label2:'90起',},
                {type:'标准',item:'回国认证',label1:'75起',label2:'90起',},
                {type:'标准',item:'驾照（两面为一页）、护照、签证',label1:'75起',label2:'90起',},
                {type:'标准',item:'学生证、军官证、工作证、退休证等',label1:'75起',label2:'90起',},
                {type:'标准',item:'（医学）出生（生育）证明、出生证、单身证明、死亡证明、无犯罪记录证明',label1:'75起',label2:'90起',},
                {type:'标准',item:'毕业证、学位证',label1:'75起',label2:'90起',},
                {type:'标准',item:'身份证（双面）、名片',label1:'75起',label2:'90起',},
                {type:'标准',item:'高中毕业证、四六级证书、计算机等级证',label1:'75起',label2:'90起',},
                {type:'标准',item:'收入证明、在职证明、在学证明、存款证明、健康证明',label1:'75起',label2:'90起',},
                {type:'标准',item:'回执、收据、进账单、划款单据、银行汇款单等',label1:'75起',label2:'90起',},
                {type:'标准',item:'购房发票、购车发票、凭证、税证、契税、税务局机打发票等',label1:'75起',label2:'90起',},
                {type:'标准',item:'营业执照、税务登记证、组织机构代码证',label1:'75起',label2:'90起',},
                {type:'标准',item:'结（离）婚证、房产证',label1:'75起',label2:'90起',},
                {type:'标准',item:'户口本（两小页算一页）',label1:'75起',label2:'90起',},
                {type:'标准',item:'职业资格证、健康证、疫苗接种证等',label1:'75起',label2:'90起',},
                {type:'标准',item:'存折',label1:'75起',label2:'90起',},

                {type:'非标准',item:'其他字数比较少的单页文件，如证明信、派遣函、委托书、通知书、声明书申请书、<br> 许可证、工资条、请假条等',label1:'75起',label2:'90起',},
                {type:'非标准',item:'小学、初中、高中成绩单、毕业证明',label1:'75起',label2:'90起',},
                {type:'非标准',item:'大学成绩单',label1:'75起',label2:'90起',},
                {type:'备注',item:'1.单页内容较多、时间较急的需酌情加价 <br>2.其他稀有语种的根据具体内容具体定价 <br>3.证件一律按页计费，且每页不超过300字',label1:'75起',label2:'90起',},
            ],
        }
    },
    mounted() {
        _comMeds.countLink(1005,100);
        this.getLanguagePriceListFuc()
    },
    methods: {
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex == 19) {
                if (columnIndex == 0) {
                    return [1, 1];
                }
                if (columnIndex == 1) {
                    return [1, 3];
                }
                return [0, 0]
            }
            if (columnIndex === 0) {
                if (rowIndex == 0) {
                    return {
                        rowspan: 16,
                        colspan: 1
                    };
                }
                if (rowIndex <= 15) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                if (rowIndex == 16) {
                    return {
                        rowspan: 3,
                        colspan: 1
                    };
                }
                if (rowIndex <= 18) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                return {
                    rowspan: 1,
                    colspan: 1
                };
            }
            if (columnIndex === 2||columnIndex === 3) {

                if (rowIndex == 0) {
                    return {
                        rowspan: 16,
                        colspan: 1
                    };
                }
                if (rowIndex <= 15) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                if (rowIndex  == 16) {
                    return {
                        rowspan: 3,
                        colspan: 1
                    };
                }
                if (rowIndex <= 18) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                return {
                    rowspan: 0,
                    colspan: 0
                };
            }
            
        },
        arraySpanMethod({row, column, rowIndex, columnIndex}) {
            if(row.level == '其他') {
                if(columnIndex == 1) {
                    return [rowIndex, 2];
                }
                if(columnIndex > 1) {
                    return [0, 0];
                }
            }
        },
        getLanguagePriceListFuc() {
            _order.getLanguagePriceList({}, res => {
                if(res) {
                    this.tableData = res.languageTransPriceVoList
                    this.tableData2 = res.transServiceExplainList
                }
            })
        }
    }

})

var page = {
    init: function () {  

    },
    onload: function () {  

    },
    bindEvent: function () {  
        
    }
}

$(function () {  
    page.init()
})